import React from 'react';
import '../styles/EventScheduleDetailCard.css';
import { BRAIN_EVENT_SCHEDULE } from '../constants/eventSchedule';

const EventScheduleDetailCard = ({ className = '', showLocation = false }) => {
  return (
    <div className={`event-schedule-card ${className}`.trim()} role="note" aria-label="Program eveniment">
      <div className="event-schedule-card-header">
        <span className="event-schedule-card-icon" aria-hidden="true">ℹ️</span>
        <h3 className="event-schedule-card-title">Program eveniment — {BRAIN_EVENT_SCHEDULE.date}</h3>
      </div>
      <p className="event-schedule-card-lead">{BRAIN_EVENT_SCHEDULE.leadMessage}</p>
      <div className="event-schedule-table-wrap">
        <table className="event-schedule-table">
          <thead>
            <tr>
              <th scope="col">Ora</th>
              <th scope="col">Activitate</th>
            </tr>
          </thead>
          <tbody>
            {BRAIN_EVENT_SCHEDULE.timeline.map((row) => (
              <tr key={`${row.time}-${row.activity}`}>
                <td className="event-schedule-table-time">{row.time}</td>
                <td className="event-schedule-table-activity">{row.activity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {showLocation && (
        <p className="event-schedule-card-location">
          <strong>Locație:</strong> {BRAIN_EVENT_SCHEDULE.location}
        </p>
      )}
    </div>
  );
};

export default EventScheduleDetailCard;
